import type { ReactNode } from "react";
import { cn } from "@wa/ui";

/**
 * The one surface this CRM is built out of: no border, a large radius and a
 * diffuse shadow. Everything that would have been a bordered box - a chart, a
 * list, an empty state, a form - sits on one of these.
 */
export function Card({
  className,
  children,
  ...rest
}: { className?: string; children: ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn("crm-card", className)} {...rest}>
      {children}
    </div>
  );
}

/**
 * The card's title row. `actions` land on the right, past the auto margin, and
 * are usually `IconBtn`s or a small pill-tab group.
 */
export function CardHead({
  title,
  sub,
  actions,
  className,
}: {
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("crm-card-head", className)}>
      <div className="crm-card-col">
        <div className="crm-card-t">{title}</div>
        {sub ? <div className="crm-card-s">{sub}</div> : null}
      </div>
      {actions ? <div className="crm-card-act">{actions}</div> : null}
    </div>
  );
}
